import { connect } from 'react-redux';
import ItemTitle from './item-title';
const mapStateToProps = (_, {
  productName,
  modifiedProductName
}) => ({
  isNewName: productName && productName !== modifiedProductName
});
export default connect(mapStateToProps)(ItemTitle);